// extracted by mini-css-extract-plugin
export default {"LoaderCreateCourse":"FetchCreateCourse_LoaderCreateCourse__pgkbc","FetchCreateCourse":"FetchCreateCourse_FetchCreateCourse__lt2X0","Img":"FetchCreateCourse_Img__hptAb"};